import React from 'react';
import styles from "./ReturnTracking.module.scss";
import DynamicTableFilters from '../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters';
import DynamicDatatable from '../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import { returnTrackingTableData } from '../../../../../views/AdminPortal/dummyData';
import StatusBadge from '../../../../common/AdminCommonComponents/StatusBadge/StatusBadge';
import ActionButton from '../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton';

const ReturnTracking = ({ setShowReturnDetails }) => {

    const options = [
        { label: "View detail", action: () => setShowReturnDetails(true) },
        { label: "Update Return Status" },
        { label: "Notify Seller" },
        { label: "Approve/Reject" },
        { label: "Initiate Refund" },
        { label: "Notify Customer" },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Return ID",
            selector: (row) => row.returnId,
            center: "true",
        },
        {
            name: "Order ID",
            selector: (row) => row.orderId,
            center: "true",
        },
        {
            name: "Seller ID",
            selector: (row) => row.sellerId,
            center: "true",
        },
        {
            name: "Costumer Name",
            selector: (row) => row.customerName,
            center: "true",
            minWidth: "160px",
        },
        {
            name: "Product Name",
            selector: (row) => row.productName,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Return Status",
            cell: (row) => <StatusBadge statusName={row.returnStatus} />,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Seller Approval",
            selector: (row) => row.sellerApproval,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Date",
            selector: (row) => row.date,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Action",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div>
            <DynamicTableFilters componentName={"Return Tracking"} onApply={handleApply} onClear={handleClear} />
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={returnTrackingTableData}
                    columns={columns}
                    type="gray"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default ReturnTracking;